import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://kqkxulsuevfuhmuvhxsp.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtxa3h1bHN1ZXZmdWhtdXZoeHNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU3NjYxMTYsImV4cCI6MjA5MTM0MjExNn0.dwPtvv9lvu_urSgno57Iu4POAKP2qANbSw5fKEcscdE'

export const supabase = createClient(supabaseUrl, supabaseKey)
